<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  import { getShortDateForSpecificLocale } from '@/utils/constants/date'
  import type { TClpBanner } from '@/components/campaign/banner/types'

  const props = defineProps<{ data: TClpBanner }>()

  const counterBase = computed(() =>
    cva('md:overflow-hidden md:rounded-lg md:max-w-330 xl:max-w-400 md:mx-auto', {
      variants: {
        theme: {
          green: 'text-bt-blue-dark bg-bt-green',
          purple: 'text-white bg-bt-grabout-violet',
          blue: 'text-white bg-bt-blue-ui'
        }
      }
    })({
      theme: props.data.color_theme || 'green'
    })
  )

  const dayjs = useDayjs()

  const { getTitleContent } = useDynamicClpBannerTitle()
  const title = getTitleContent(props.data)
</script>
<template>
  <div class="w-full md:px-10 xl:px-0">
    <div :class="counterBase">
      <slot />
      <div class="container flex flex-col items-center px-5 pb-24 pt-10 md:pb-28 xl:pb-28 xl:pt-14">
        <h1 class="mb-6 w-full text-left sm:text-center">
          {{ title }}
        </h1>
        <div class="flex w-full items-center justify-between gap-5 sm:w-fit sm:justify-normal sm:gap-10">
          <div class="flex flex-col items-start sm:items-center">
            <p class="mb-2 text-subtitle-1">{{ $t('book') }}</p>
            <div class="sm:flex">
              <LazyCampaignBannerDateRange
                :start-date="dayjs(data.book_date_start).format(getShortDateForSpecificLocale($i18n.locale))"
                :end-date="dayjs(data.book_date_end).format(getShortDateForSpecificLocale($i18n.locale))"
              />
            </div>
          </div>
          <LazyCampaignBannerFakeButton />
          <div class="flex flex-col items-start sm:items-center">
            <p class="mb-2 text-subtitle-1">{{ $t('travel') }}</p>
            <div class="sm:flex">
              <LazyCampaignBannerDateRange
                :start-date="dayjs(data.travel_date_start).format(getShortDateForSpecificLocale($i18n.locale))"
                :end-date="dayjs(data.travel_date_end).format(getShortDateForSpecificLocale($i18n.locale))"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
